import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: false,
});

// Attach Authorization header if token in localStorage (fallback for cross-site cookies)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("ucs_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const formatErr = (detail) => {
    if (detail == null) return "Er is iets misgegaan. Probeer het opnieuw.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
    if (detail?.msg) return detail.msg;
    return String(detail);
};

export const formatPrice = (n) =>
    new Intl.NumberFormat("nl-BE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

export const formatKm = (n) => new Intl.NumberFormat("nl-BE").format(n || 0) + " km";

export const resolveImage = (url) => {
    if (!url) return "";
    if (url.startsWith("http")) return url;
    if (url.startsWith("/api")) return `${BACKEND_URL}${url}`;
    return `${API}/files/${url}`;
};
